import { useEffect, useState } from "react";
import { useDispatch } from 'react-redux'
import { setCurrPage } from '../slices/sideBarSlice'
import { stageDescriptions } from '../common/stageConstants'

export default function StageLine(props) {
    const dispatch = useDispatch();
    const [text, setText] = useState();
    const [guideText, setGuideText] = useState('');

    // The text depends on the stage of the conversation
    useEffect(() => {
        if (props.text === "This is the end of this conversation.") {
            setText(<>This is the end of this coaching. Back to <button className="text-[#1993D6] hover:text-[#9ADBFF] underline" onClick={() => dispatch(setCurrPage('welcome'))}>Home</button> page</>);
        } else {
            setText(`Below is ${props.text.charAt(0).toUpperCase() + props.text.slice(1)} Stage`);
            setGuideText(stageDescriptions[props.text]);
        }
    }, [])

    // Stage line
    return (
        <div className="flex flex-col items-center py-5" id={`stageLine-${props.text}`}>
            <div className="w-full border-t border-[#494949]"></div>
            <span className="mx-4 my-2 text-[#a3a3a3]">{text}</span>
            <p className="text-[#a3a3a3] mt-0">{guideText}</p>
        </div>
    );
}
